import { render } from "./CollectionPageContainer.vue?vue&type=template&id=c5bcec0c&scoped=true"
import script from "./CollectionPageContainer.vue?vue&type=script&lang=js"
export * from "./CollectionPageContainer.vue?vue&type=script&lang=js"

import "./CollectionPageContainer.vue?vue&type=style&index=0&id=c5bcec0c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5bcec0c"]])

export default __exports__